import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const EbmReportTisk = lazy(() =>
  import('@/modules/management/EbmReportTisk').then((m) => ({ default: m.EbmReportTisk })),
);

type EbmTiskTyp = 'vykaz' | 'rozvaha_aktiva' | 'rozvaha_pasiva';

interface EbmReportTiskSearch {
  importId?: number;
  typ?: EbmTiskTyp;
}

function parseEbmReportTiskSearch(input: Record<string, unknown>): EbmReportTiskSearch {
  const out: EbmReportTiskSearch = {};
  const id = Number(input.importId);
  if (Number.isInteger(id) && id > 0) out.importId = id;
  if (input.typ === 'vykaz' || input.typ === 'rozvaha_aktiva' || input.typ === 'rozvaha_pasiva') {
    out.typ = input.typ;
  }
  return out;
}

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/management/ebm/report/tisk',
  component: () => (
    <Suspense fallback={null}>
      <EbmReportTisk />
    </Suspense>
  ),
  validateSearch: parseEbmReportTiskSearch,
});
